"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Plus } from "lucide-react";
const faqData = [{
  id: "item-1",
  question: "Jakie odszkodowania mogę otrzymać po wypadku komunikacyjnym?",
  answer: "Po wypadku komunikacyjnym możesz ubiegać się o odszkodowanie z polisy OC sprawcy za szkody majątkowe (np. zniszczenie pojazdu, koszty leczenia) oraz zadośćuczynienie za krzywdę (ból, cierpienie, skutki zdrowotne). Każdą sprawę analizujemy indywidualnie, oceniając odpowiedzialność sprawcy i podstawy prawne roszczeń."
}, {
  id: "item-2",
  question: "Jak długo trwa postępowanie o odszkodowanie?",
  answer: "Czas trwania postępowania zależy od złożoności sprawy i współpracy z ubezpieczycielem. Sprawy przedsądowe mogą zakończyć się w ciągu kilku miesięcy, natomiast postępowania sądowe mogą trwać od roku do dwóch lat. Staramy się maksymalnie przyspieszyć proces poprzez rzetelną analizę dokumentacji i skuteczną reprezentację."
}, {
  id: "item-3",
  question: "Czy mogę dochodzić zadośćuczynienia po wypadku przy pracy?",
  answer: "Tak, jeśli doznałeś obrażeń w wypadku przy pracy, możesz ubiegać się o zadośćuczynienie od pracodawcy lub ubezpieczyciela, jeśli odpowiedzialność cywilna została ustanowiona. Prowadzimy szczegółową analizę okoliczności wypadku oraz odpowiedzialności prawnej, aby określić przysługujące Ci roszczenia."
}, {
  id: "item-4",
  question: "Jakie dokumenty są potrzebne do wszczęcia sprawy odszkodowawczej?",
  answer: "Do wszczęcia sprawy zazwyczaj potrzebna jest dokumentacja medyczna (karty informacyjne, zaświadczenia lekarskie), protokół z wypadku (policyjny, z zakładu pracy), potwierdzenia poniesionych kosztów oraz polisa OC sprawcy. Podczas pierwszej konsultacji omówimy, jakie dokumenty są niezbędne w Twojej konkretnej sprawie."
}, {
  id: "item-5",
  question: "Czy rodzina może ubiegać się o odszkodowanie po śmierci bliskiej osoby?",
  answer: "Tak, członkowie najbliższej rodziny osoby zmarłej w wyniku wypadku mogą ubiegać się o zadośćuczynienie za doznaną krzywdę oraz o odszkodowanie obejmujące koszty pogrzebu i utratę wsparcia materialnego. Każdą sprawę prowadzimy z najwyższą dbałością i szacunkiem dla trudnej sytuacji rodziny."
}, {
  id: "item-6",
  question: "Czy pomagacie w sprawach dotyczących błędów medycznych?",
  answer: "Tak, prowadzimy sprawy dotyczące odpowiedzialności za zdarzenia medyczne. Każda sprawa rozpoczyna się od szczegółowej analizy dokumentacji medycznej oraz oceny podstaw prawnych odpowiedzialności. Współpracujemy z biegłymi, aby skutecznie dochodzić należnych roszczeń."
}, {
  id: "item-7",
  question: "Jak przebiega współpraca z kancelarią?",
  answer: "Współpraca rozpoczyna się od konsultacji, podczas której omawiamy okoliczności sprawy i oceniamy podstawy prawne roszczeń. Następnie przygotowujemy dokumentację i reprezentujemy Cię w kontaktach z ubezpieczycielem oraz przed sądem. Zapewniamy wsparcie prawne na każdym etapie postępowania, zarówno zdalnie, jak i osobiście w Słupsku."
}];
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="faq" ref={ref} className={`bg-background py-16 md:py-24 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <h2 className="text-center mb-12 md:mb-16">
          Najczęściej zadawane pytania
        </h2>

        <Accordion type="single" collapsible className="w-full space-y-0">
          {faqData.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="border-b border-border transition-colors duration-[var(--duration-fast)]">
              <AccordionTrigger className="group flex items-start justify-between py-6 text-left hover:no-underline focus-visible:outline-none">
                <span className="text-lg md:text-xl font-display font-semibold text-foreground pr-4 group-hover:translate-x-2 transition-transform duration-[var(--duration-fast)] ease-[var(--ease-smooth)]">
                  {item.question}
                </span>
                <Plus className="text-primary shrink-0 size-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-data-[state=open]:rotate-45" />
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg text-muted-foreground leading-relaxed animate-accordion-down">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}